import React, { useEffect, useState } from 'react'
import { Link, useHistory, useLocation } from 'react-router-dom'
import { Formik, useFormik } from 'formik'
import { useSnackbar } from 'notistack'
import { request } from '../../Utils/Request'
import './registrationStep1.css'
import CustomInput from '../../components/atoms/Inputs/CustomInput'
import CustomSelect from '../../components/atoms/Inputs/CustomSelect'
import PrimaryButton from '../../components/atoms/PrimaryButton'
import { register1Schema } from './register1Schema'
import csc from 'country-state-city'
import RadioBox from '../../components/atoms/RadioBox'
import { useTranslation } from 'react-i18next'

const RegistrationStep1 = () => {
    const history = useHistory()
    const location = useLocation()
    const { t } = useTranslation()
    const { enqueueSnackbar } = useSnackbar()
    //Initially ROle is set as buyer as per default radio value input field
    const [getRole, setGetRole] = useState(0)
    const [ambassador] = useState(
        new URLSearchParams(window.location.search.substring(1)).get('ambassador'),
    )
    const [userDetails, setUserDetails] = useState({
        full_name: '',
        last_name: '',
        email: '',
        phone: '',
        address: '',
        city: '',
        country: '',
        zip_code: '',
        role: '1',
        orgNum: '',
    })

    const formik = useFormik({
        initialValues: userDetails,
        validationSchema: register1Schema(),
        onSubmit: (values, { setSubmitting }) => {
            signUpRedirect(values)
            setSubmitting(false)
        },
    })

    const [states, setStates] = useState([])
    const [country, setCountry] = useState('')
    console.log('$====>', country)

    useEffect(() => {
        if (country) {
            const fetchedStates = csc.getStatesOfCountry(country)
            setStates(fetchedStates)
        } else {
            setStates([])
        }
    }, [country])
    const signUpRedirect = async (val) => {
        const step_1_data = {
            first_name: val.full_name,
            last_name: val.last_name,
            email: val.email,
            phone: val.phone,
            address: val.address,
            city: val.city,
            state: val.state,
            country: val.country,
            zip_code: val.zip_code,
            searchUrl: location.search,
            role: val.role,
            isseller: ambassador,
            orgNum: val.orgNum,
        }

        try {
            enqueueSnackbar('Validating your email!', { variant: 'info' })
            const res = await request('post', '/checkEmailExistance', { email: val.email })
            if (res.data.status) {
                const res2 = await request(
                    'post',
                    `/send_otp_email?email=${encodeURIComponent(val.email)}`,
                    { site_id: process.env.REACT_APP_SITE_ID },
                )

                if (res2.data.status == 'yes') {
                    enqueueSnackbar('Your email validated successfully!', { variant: 'info' })
                    history.push({
                        pathname: `/otpVerification`,
                        state: step_1_data,
                    })
                    // history.push({
                    //     pathname: `/otpVerification?role=${step_1_data.role}&isseller=${ambassador}`,
                    //     state: step_1_data,
                    // })
                } else {
                    return enqueueSnackbar(res2.data.message, { variant: 'error' })
                }
            } else {
                return enqueueSnackbar(res.data.message, { variant: 'error' })
            }
        } catch (error) {
            console.log(error)
        }
    }

    const handleChangeRadio = (e) => {
        formik.setFieldValue(e.target.name, e.target.value)
    }

    console.log('Role State', getRole)

    return (
        <div className="mobile-signup row m-0">
            <div className="col-lg-6 col-12 login-content-area">
                <h2 className="text-left light-white">{t('welcome_to_carzaar')}</h2>
                <p className="text-left mb-1">{t('select_your_role')}</p>

                <div className="signup-area-content">
                    <form className="sign-up-content" onSubmit={formik.handleSubmit}>
                        <RadioBox
                            name="role"
                            items={[
                                { id: '1', description: t('seller') },
                                { id: '0', description: t('buyer') },
                                { id: '4', description: t('ambassador') },
                            ]}
                            parentRadioClassName="user-type-radio"
                            radioClassName="user-type-group"
                            labelClassName="user-type-label"
                            onChange={(e) => (handleChangeRadio(e), setGetRole(e.target.value))}
                            value={formik.values.role}
                            helperText={formik.touched.role && formik.errors.role}
                        />
                        <div className="signup-content-input row">
                            <CustomInput
                                label={t('first_name')}
                                name="full_name"
                                value={formik.values.full_name}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-6"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.full_name && formik.errors.full_name}
                            />
                            <CustomInput
                                label={t('last_name')}
                                name="last_name"
                                value={formik.values.last_name}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-6"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.last_name && formik.errors.last_name}
                            />
                            <CustomInput
                                label={t('email')}
                                type="email"
                                name="email"
                                value={formik.values.email}
                                onChange={formik.handleChange}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-6"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.email && formik.errors.email}
                            />
                            <CustomInput
                                label={t('phone_number')}
                                name="phone"
                                value={formik.values.phone}
                                onChange={formik.handleChange}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-6"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.phone && formik.errors.phone}
                            />
                            <CustomInput
                                label={t('address_line')}
                                name="address"
                                value={formik.values.address}
                                onChange={formik.handleChange}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-6"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.address && formik.errors.address}
                            />
                            <CustomInput
                                label={t('city')}
                                name="city"
                                value={formik.values.city}
                                onChange={formik.handleChange}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-6"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.city && formik.errors.city}
                            />
                            <CustomSelect
                                label={t('country')}
                                name="country"
                                value={formik.values.country}
                                onChange={(e) => (
                                    formik.handleChange(e), setCountry(e.target.value)
                                )}
                                labelClass="text-left light-white"
                                selectClassName="input-login customeSelect col-md-6"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.country && formik.errors.country}
                            >
                                <option value="">{t('select_country')}</option>
                                {getRole != 1 ? (
                                    csc.getAllCountries().map((country) => (
                                        <option key={country.isoCode} value={country.id}>
                                            {country.name}
                                        </option>
                                    ))
                                ) : (
                                    <option key="211" value="211">
                                        Sweden
                                    </option>
                                )}
                            </CustomSelect>
                            <CustomSelect
                                label={t('state')}
                                name="state"
                                value={formik.values.state}
                                onChange={formik.handleChange}
                                labelClass="text-left light-white"
                                selectClassName="input-login customeSelect col-md-6"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.state && formik.errors.state}
                            >
                                <option value="">{t('select_state')}</option>
                                {states.map((state) => (
                                    <option key={state.isoCode} value={state.isoCode}>
                                        {state.name}
                                    </option>
                                ))}
                            </CustomSelect>

                            <CustomInput
                                label={t('postcode')}
                                type="number"
                                name="zip_code"
                                value={formik.values.zip_code}
                                onChange={formik.handleChange}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-12"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.zip_code && formik.errors.zip_code}
                            />

                            <CustomInput
                                label={`${t('organisation/vat_number')} ${
                                    formik.values.role != 1 ? '' : `(${t('optional')})`
                                }`}
                                type="text"
                                name="orgNum"
                                value={formik.values.orgNum}
                                onChange={formik.handleChange}
                                labelClass="text-left light-white"
                                inputClassName="input-login  col-md-12"
                                onBlur={formik.handleBlur}
                                helperText={formik.touched.orgNum && formik.errors.orgNum}
                            />
                        </div>
                        <div className="login-confirm-button">
                            <PrimaryButton
                                label={t('send_verification_code')}
                                // disabled={isSubmitting}
                                iconRight={<span className="material-icons">arrow_right_alt</span>}
                                type="submit"
                            />
                        </div>
                    </form>
                </div>
            </div>
            <div className="col-lg-6 col-12 p-0 borderRight">
                <div className="login-car-image">
                    <div className="car-container">
                        <div className="car-image-contents">
                            <h4 className="light-black">{t('information_privacy')}</h4>
                            <p className="light-black">{t('your_informationn_safe')}</p>
                        </div>
                    </div>
                    {/* <div className="car-image-contents bottom2">
                        <h4 className="light-black">{t('quick_easy')}</h4>
                        <p className="light-black">{t('set_your_car')}</p>
                    </div>
                    <div className="car-image-contents bottom3">
                        <h4 className="light-black">{t('do_you_need')}?</h4>
                        <p className="light-black">
                            {t('call_sms')} <a href="tel:+46 728 552 329">+46 728 552 329&nbsp;</a>
                            {t('via_chat')}
                        </p>
                    </div> */}
                </div>
            </div>
        </div>
    )
}

export default RegistrationStep1
